import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Locale } from '../models/locale.model';
import { MatSnackBar } from '@angular/material/snack-bar';

import localesQuery from 'src/app/graphql/queries/locales.query.graphql'

@Injectable()
export class LocaleService extends GraphQLService<Locale> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  getAvailableLocales(): Observable<Locale[]> {
    return this.findAll(localesQuery)
  }

}
